var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutoStoriesFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 40q-2.4-1.9-5.2-2.95Q16 36 13 36q-2.1 0-4.125.55T5 38.1q-1.05.55-2.025-.05Q2 37.45 2 36.3V12.2q0-.55.275-1.05t.825-.75q2.3-1.2 4.8-1.8Q10.4 8 13 8q2.9 0 5.675.75T24 11v25.3q2.55-1.65 5.35-2.475Q32.15 33 35 33q1.8 0 3.925.35T43 34.8V9.55q.5.2.975.4t.925.45q.5.3.8.775.3.475.3 1.025v24.1q0 1.15-.975 1.75-.975.6-2.025.05-1.85-1-3.875-1.55T35 36q-3 0-5.8 1.05T24 40Zm3-8.35V14L40 1v19.35Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoStoriesFilled);
export default __webpack_public_path__ + "static/media/auto_stories_filled.eba3fe6683266de18c8ea36983045d25.svg";
export { ForwardRef as ReactComponent };